/**
 * Created by mateimisarca on 2019-06-07
 */

import Courses from './courses';
export default Courses;
